function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CommentList from './comment-list';
import CommentForm from './comment-form';
import Button from '../../components/button';
import { Heading } from "../../components/text";
import { TineUserFeedbackProvider, fetchComments } from './comment-service';
import './comments.scss';
export var Comments = function (_ref) {
  var _ref$PAGE_SIZE = _ref.PAGE_SIZE,
    PAGE_SIZE = _ref$PAGE_SIZE === void 0 ? 3 : _ref$PAGE_SIZE,
    className = _ref.className,
    endpoint = _ref.endpoint,
    siteKey = _ref.siteKey,
    contentKey = _ref.contentKey,
    contentTitle = _ref.contentTitle,
    url = _ref.url;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comments = _useState4[0],
    setComments = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showCommentForm = _useState6[0],
    setShowCommentForm = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    commentSubmitted = _useState8[0],
    setCommentSubmitted = _useState8[1];
  useEffect(function () {
    fetchComments({
      endpoint: endpoint,
      siteKey: siteKey,
      contentKey: contentKey
    }).then(function (res) {
      setComments(res);
    });
  }, []);
  useEffect(function () {
    if (commentSubmitted) {
      var timer = setTimeout(function () {
        setCommentSubmitted(false);
      }, 10000);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [commentSubmitted]);
  var activeComments = comments ? comments.slice(0, page * PAGE_SIZE) : [];
  var updateCommentform = function () {
    setCommentSubmitted(true); // Update state on comment submission
    fetchComments({
      endpoint: endpoint,
      siteKey: siteKey,
      contentKey: contentKey
    }).then(function (res) {
      setComments(res);
    });
  };
  return /*#__PURE__*/React.createElement(TineUserFeedbackProvider, {
    endpoint: endpoint,
    siteKey: siteKey,
    contentKey: contentKey,
    contentTitle: contentTitle,
    url: url
  }, /*#__PURE__*/React.createElement("section", {
    className: "o-comments ".concat(className),
    itemScope: true,
    itemType: "http://schema.org/UserComments",
    id: "comments"
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "o-comments__heading",
    text: "Kommentarer",
    element: "h2"
  }), commentSubmitted && /*#__PURE__*/React.createElement("div", {
    className: "moderation-message"
  }, "Din kommentar er sendt for godkjenning."), showCommentForm ? /*#__PURE__*/React.createElement(CommentForm, {
    toggleCommentForm: function () {
      return setShowCommentForm(!showCommentForm);
    },
    updateCommentform: updateCommentform
  }) : /*#__PURE__*/React.createElement(Button, {
    action: "primary",
    onClick: function () {
      return setShowCommentForm(!showCommentForm);
    }
  }, "Skriv en kommentar"), /*#__PURE__*/React.createElement("div", {
    className: "o-comments__content"
  }, /*#__PURE__*/React.createElement(CommentList, {
    comments: activeComments,
    updateCommentform: updateCommentform
  })), comments.length > page * PAGE_SIZE && /*#__PURE__*/React.createElement(Button, {
    action: "secondary",
    onClick: function () {
      return setPage(page + 1);
    }
  }, "Last inn flere kommentarer")));
};
Comments.propTypes = {
  endpoint: PropTypes.string.isRequired,
  siteKey: PropTypes.string.isRequired,
  contentKey: PropTypes.string.isRequired,
  contentTitle: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
  PAGE_SIZE: PropTypes.number
};
export default Comments;